import { Pipe, PipeTransform } from '@angular/core';
import { INDRADateService } from '@ibe.services/date.indra.service';
import * as _ from 'lodash';

@Pipe({
  name: 'dateIndra'
})
export class DateIndraPipe implements PipeTransform {

	constructor(
		private service: INDRADateService
	) {}

	transform(value: any, format?: any): any {
		if (_.isEmpty(value)) {
			return '';
		}
		return this.service.INDRA_formatDate(value, format || 'DD/MM/YYYY');
	}

}
